import { render } from "./CapabilityHumanenessChart.vue?vue&type=template&id=64b7c72c&scoped=true&ts=true"
import script from "./CapabilityHumanenessChart.vue?vue&type=script&lang=ts"
export * from "./CapabilityHumanenessChart.vue?vue&type=script&lang=ts"

import "./CapabilityHumanenessChart.vue?vue&type=style&index=0&id=64b7c72c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64b7c72c"]])

export default __exports__